import "./button.css";
import { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  theme: "primary" | "secondary";
}

const Button = (props: ButtonProps) => {
  const { theme, ...buttonProps } = props;
  const themeClassname =
    theme === "primary" ? "button-primary" : "button-secondary";
  return (
    <button className={themeClassname} {...buttonProps}>
      {props.children}
    </button>
  );
};

export default Button;
